import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import timer from 'app/managecustomer/Timer';
import { CustomerNoteService } from '../../../services/customer-note.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import Utils from '../../../shared/utils';

@Component({
	selector: 'app-components-managecustomer-floatingcustomernote',
	templateUrl: './FloatingCustomerNote.component.html'
})
export class FloatingCustomerNoteComponent implements OnInit {
    @Input() customerId: number;
    @Output() floatingNoteSaved: EventEmitter<void> = new EventEmitter<void>();
    contactTypeId: KnockoutObservable<number>;
    contactTypes: Boo.Objects.ContactType[];
    
    customerNotePanel: IJQueryFloatPanel;
    noteText: KnockoutObservable<string>;

    private validation: KnockoutObservable<any>;

    constructor(
      private customerNoteService: CustomerNoteService,
      private sessionStorageService: SessionStorageService) { }

    ngOnInit() {
        this.contactTypeId = ko.observable(undefined); // must be undefined or else validation msg doesn't show sometimes
        this.noteText = ko.observable(undefined);
        
        this.customerNotePanel = ($('#customer-note-float-panel') as any).floatPanel({ collapsed: true });

        this.contactTypeId.extend({
            required: true
        });

        this.noteText.extend({
            required: true,
            maxLength: 4000,
            validation: { validator: Utils.containsNoHtml, message: 'Html tags are not allowed.  You cannot have a < followed by a >' }
        });

        this.validation = ko.validatedObservable({
            contactTypeId: this.contactTypeId,
            noteText: this.noteText
        });

        this.sessionStorageService.getStaticData()
            .subscribe(staticData => {
                this.contactTypes = staticData.ContactTypes.filter(x => x.ContactTypeId !== Boo.Objects.Enums.ContactTypeEnum.NoteRevision);
            });
    }

    public save(): void {
        if (!this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return;
        }
        const note: Boo.Objects.CustomerNote = {
            CustomerId: this.customerId,
            Text: this.noteText(),
            FollowupDate: moment(moment().format('L')).toDate(),
            Duration: (timer.getElapsedSecondsSinceLastCustomerTouch()),
            ContactTypeId: this.contactTypeId()
        } as Boo.Objects.CustomerNote;
        this.customerNoteService.save(note)
        .subscribe(() => {
            this.contactTypeId(undefined);
            this.noteText(undefined);
            this.customerNotePanel.floatPanel('collapse');
            this.floatingNoteSaved.emit();
        });
    }
}
